import { Component, CUSTOM_ELEMENTS_SCHEMA, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { ShToggleAccessorComponent } from '../../ui/sh-toggle-accessor/sh-toggle-accessor.component';

@Component({
    selector: 'app-settings-email-notifications-section',
    standalone: true,
    templateUrl: './settings-email-notifications-section.component.html',
    imports: [ReactiveFormsModule, ShToggleAccessorComponent, TranslatePipe],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SettingsEmailNotificationsSectionComponent {
    public notificationForm = input.required<FormGroup>();
}
